import {
    ProductTypeConfig, commitmentTypeDisplay, productTypeDisplay
} from '@api';
import { Paper } from '@mui/material';
import { LabelGroup, LabeledValue } from '@tsp-ui/core/components';
import { Fragment } from 'react';

import styles from './EligibleProductsLimitCard.module.scss';


interface EligibleProductsLimitCardProps {
    config: ProductTypeConfig;
}

export default function EligibleProductTypeChangeCard({ config }: EligibleProductsLimitCardProps) {
    return (
        <Paper
            variant="outlined"
            className={styles.root}
        >
            <LabelGroup title={productTypeDisplay[config.productType]}>
                <LabeledValue
                    label="Commitment types:"
                    value={config.allowedCommitmentTypes?.map(commitmentType => (
                        <Fragment key={commitmentType}>
                            {commitmentTypeDisplay[commitmentType]}<br />
                        </Fragment>
                    )) || 'None'}
                />

                <LabeledValue
                    label="Lock periods:"
                    value={config.allowedLockPeriods?.map(lockPeriod => (
                        <Fragment key={lockPeriod}>
                            {lockPeriod}<br />
                        </Fragment>
                    )) || 'None'}
                />
            </LabelGroup>
        </Paper>
    );
}
